import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/module/page',
  ADD: '/dh-datamaint/module/add',
  DELETE: '/dh-datamaint/module/delete',
  DETAIL: '/dh-datamaint/module/getById',
  UPDATE: '/dh-datamaint/module/update',
  MODULE_LIST: '/dh-datamaint/module/listAll'
};

class EncryptionModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async getModuleList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.MODULE_LIST, { params: payload.data });
    }
  };
}

export const encryptionModule = new EncryptionModule();
